import {useStore} from "zustand";

import {useFluxServices} from "injection/hooks";

/**
 * Hook to get the current auto-layout job from the store.
 * @returns The current auto-layout job or undefined.
 */
export function useCurrentAutoLayoutJob() {
    const {autoLayoutStoreService} = useFluxServices();

    const store = autoLayoutStoreService.getStore();

    const currentJob = useStore(store, (state) => state.currentJob);

    return currentJob;
}
